import { FC, ReactNode } from 'react';
import { IImport } from '../../../model/IImport';
import { IOnSort } from '../../hooks/usePagable';
import { icons } from '../../icons/IconSet';
import { IPagable } from '../../services/IPagable';
import Table, { ITableTh } from '../common/table/Table';
import ImportsTaskRow from './ImportsTaskRow';

export interface IImportsList {
  imports?: IImport[],
  pagable?: IPagable,
  isPending?: boolean,
  loadTriggerComponent?: ReactNode,
  onSort?: IOnSort,
}

const ImportsList: FC<IImportsList> = ({  
  pagable,
  imports,
  isPending = false,
  loadTriggerComponent,
  onSort,
}) => {
  const thead: ITableTh[] = [
    { title: ' ', align: 'center', sortCol: 'status' },
    { title: ' ', align: 'center', sortCol: 'goalServer' },
    { title: '#', align: 'center', sortCol: 'productId' },
    { title: icons('factory', { width: '1.3em' }), align: 'center', sortCol: 'company' },
    { title: icons('calendar-arrow-down', { width: '1.3em' }), align: 'center', sortCol: 'createdAt' },
    { title: 'Last Product Upd', align: 'center', sortCol: 'productUpdatedAt' },
  ];

  return (
    <>
      <Table
        options={[
          <div className="flex gap-2">
          </div>
        ]}
        pagable={pagable}
        isPending={isPending}
        onSort={onSort}
        size="small"
        thead={thead}
        theadClassName=""
        trs={[...(imports || [])].map((imprt) => (
          <ImportsTaskRow 
            key={`row-${imprt.idImport}`}
            imprt={imprt}
          />
        ))}        
      />
      {!!loadTriggerComponent && !isPending && loadTriggerComponent}
    </>
  );
}

export default ImportsList;
